// extracted by mini-css-extract-plugin
module.exports = {"details":"_3EEo1","content":"_1tljk","title":"drw1O","authorAndCategory":"_1YzzA","author":"_285xU","cta":"_1cxFp"};